import { all } from 'redux-saga/effects'
import { watchForToasts } from "./toasts"
import { watchReorderTemplates } from "shape-list/sagas/reorder_templates"
import { watchTemplateFormChanged } from "template-edit/sagas/undoRedoHistory"
import { watchActiveShapeOrViewChanged } from "template-edit/sagas/active-shape-changed"

import {
    watchCreateProductsExport,
    watchCreateTemplateExport,
    watchCreateSimilarityExport,
    watchGetProductsExport,
    watchGetTemplateExport,
    watchGetSimilarityExport,
} from "./exports"

export default function* rootSaga(): any {

    yield all([
        watchForToasts(),
        watchReorderTemplates(),
        watchTemplateFormChanged(),
        watchActiveShapeOrViewChanged(),
        watchCreateProductsExport(),
        watchCreateTemplateExport(),
        watchCreateSimilarityExport(),
        watchGetProductsExport(),
        watchGetTemplateExport(),
        watchGetSimilarityExport(),
    ])
}